var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`dot-animation-wrapper dot-size-${_vm.size}`},[_c('div',{staticClass:"dot-group"},_vm._l((_vm.dots),function(dot,index){return _c('div',{key:`dot-${index}`,staticClass:"dot",class:{ invisible: _vm.hiddenDots.find((element) => element === index) }})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }